import AbstractAxiosService from './AbstractAxiosService'
import { config } from '@/config'

export default class ContaoService extends AbstractAxiosService {
  constructor (options = {}) {
    super(options)
  }

	orderVouchers({ vouchers, printAtHome, shippingAddress, billingAddress, phoneNumber, email, message, checkAgb, sendAsGift, lang = config.LANGUAGE, locale = config.LOCALE }) {
		return this.makeRequest('post', '/api/vouchers/buy', { vouchers, printAtHome, shippingAddress, billingAddress, phoneNumber, email, message, checkAgb, sendAsGift }, { params: { lang, locale } });
	}

	checkVoucherBalance({ cardNumber, lang = config.LANGUAGE, locale = config.LOCALE }) {
		return this.makeRequest('post', '/api/vouchers/balance', { cardNumber }, { params: { lang, locale } });
	}

	reloadVoucher({ cardNumber, cvc, value, lang = config.LANGUAGE, locale = config.LOCALE }) {
		return this.makeRequest('post', '/api/vouchers/reload', { cardNumber, cvc, value }, { params: { lang, locale } });
	}

	// COURSE
	courseRegistration({ form, lang = config.LANGUAGE, locale = config.LOCALE }) {
		return this.makeRequest('post', '/api/course/register', form, { params: { lang, locale } })
	}

	// JOBS
	jobs({workAreas, canton, brand, lang = config.LANGUAGE, locale = config.LOCALE }) {
		const params = {
			lang,
			locale
		}

		if (workAreas) {
			params.workAreas = workAreas
		}

		if (canton) {
			params.canton = canton
		}

		if (brand) {
			params.brand = brand
		}

		return this.makeRequest('get', '/api/jobs', { params })
	}
}
